import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PolicyService } from '../../../FunctionalModules/PolicyIssuance/policy.service';

import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';

import { AdjudicationDO } from 'app/BaseFramework/shared/models';

interface benefitDO {
  id: Number,
  productVersion: any,
  productCd: any,
  benefitCd: any,
  event: any,
  benefitAmt: any,
  approveAmt: any,
  decisionCd: any,
  note: any,
}
@Component({
  selector: 'app-claims-benefit',
  templateUrl: './claims-benefit.component.html',
  styleUrls: ['./claims-benefit.component.scss']
})
export class ClaimsBenefitComponent implements OnInit {
  _currentComponentName = 'ClaimsBenefitComponent'
  constructor(private viewContainerRef: ViewContainerRef,
    public validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    private policyService: PolicyService,
    public appMetadataHandler: AppMetadataHandler

  ) { }

  //Declaraions which might need developer input
  claimsBenefitForm: FormGroup
  CLAIMSBENEFITFORM = "claimsBenefitForm"
  selectorOfThisComponent = 'app-claims-benefit'
  parentEvent$

  selecteClaimDO: any;


  emptyBenfitDO: benefitDO = {
    id: null,
    productVersion: null,
    productCd: null,
    benefitCd: null,
    event: null,
    benefitAmt: null,
    approveAmt: null,
    decisionCd: null,
    note: null
  }

  benefitZeroState = {
    title: "No Benefits found",
    message: "No benefits were found for this Claim",
    icon: null
  }

  benefitList: any[] = []
  lookupsToBind = ['manualAdjDecisionCd']
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  DO: any;
  @Input() transaction: any;

  private _IO = null;
  @Input()
  set IO(value: any) {
    this._IO = value;
    this.getDOAndSetPolicy();
  };

  private getDOAndSetPolicy() {

    this.DO = this.getDO(this._IO);
    if (this.DO != null) {
      this.benefitList = this.getBenefitList(this.DO);
    }
  }

  get IO() {
    return this._IO;
  }


  getDO(IO) {
    let output = null
    if (IO != null) {
      switch (this.transaction) {
        case "benefit": {
          if (IO['intimationDO'] || IO['claimDO'] || IO['investigationDO'] || IO['proposalDO'] || IO['caseDO']) {
            //    output = IO['intimationDO']['policies'] || IO['claimDO']['policies'];
            if (IO['intimationDO'])
              output = IO['intimationDO']

            if (IO['claimDO'])
              output = IO['claimDO']

            if (IO['investigationDO'])
              output = IO['investigationDO']

            if (IO['proposalDO'])
              output = IO['proposalDO']
            if (IO['caseDO'])
              output = IO['caseDO']

            break;
          }
        }
        default: {
          console.log("Invalid choice");
          break;
        }
      }
    }

    return output
  }



  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): string {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      this.EmitComponentOutput(this.setBenefitList(this.benefitList, this.DO));
    })
  }

  validateOutput(o) {
    this.commonUtilty.markAllFieldDirty(o);
    return true
  }


  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }
    if (this.IO != null)
      this.initializeClientSearchForm(this.IO)
    this.subscribeToParentEvent()
  }

  tempBenefit1: string = `250000`;
  tempBenefit2: string = `20000`;
  tempBenefit3: string = `350000`;
  tempBenefitTotal: string = `150000`;


  /**
   * Form Trasactions
   */

  initializeClientSearchForm(data?) {
    let payload = data || {}
    this.claimsBenefitForm = this.fb.group({

    });
  }

  isRequired(fieldName) {
    let returnObj = this.validationUtilService.isRequired(fieldName, this.CLAIMSBENEFITFORM)
    return returnObj
  }

  totalAmount = 0
  updateBenefitTotal(benefitList) {
    let totalSum: number = benefitList.reduce((acc, benefit) => {
      return parseInt(typeof acc === 'number' ? acc.toString() : acc) + parseInt(typeof benefit.benefitAmt === 'number' ? benefit.benefitAmt.toString() : benefit.benefitAmt);
    }, 0);
    this.totalAmount = totalSum
  }

  getBenefitList(claimDO) {
    let benefitList = []
    if (claimDO) {
      claimDO.claimCoverages.forEach(claimCoverage => {
        let newBenefit: benefitDO = this.commonUtilty.deepCopy(this.emptyBenfitDO);
        newBenefit.productCd = claimCoverage.productCd;
        newBenefit.productVersion = claimCoverage.productVersion
        claimCoverage.benefits.forEach(benefit => {
          newBenefit.benefitCd = benefit.benefitCd;
          newBenefit.benefitAmt = benefit.benefitAmt;
          // newBenefit.approveAmt = benefit.claimedAmt;

          //---------Code Start------------Ninad: Code added to check benefit decision in edit mode.
          let adjDO = benefit.adjudications.find(adj => adj.levelCd == claimDO.adjudicationLevel)
          if (!!adjDO) {
            newBenefit.decisionCd = adjDO.adjDecisionCd
            newBenefit.approveAmt = adjDO.approvedClaimAmt
            newBenefit.note = adjDO.remarks
          }
          //---------Code Ends------------Ninad: Code added to check benefit decision in edit mode.
          benefitList.push(newBenefit);
        });
      });

    }
    this.updateBenefitTotal(this.benefitList)

    return benefitList
  }

  setBenefitList(benefitList: Array<benefitDO>, claimDO) {
    let benefitListMap = this.convertUIBenefitListToMap(benefitList);
    if (claimDO && benefitList) {
      claimDO.claimCoverages.forEach(claimCoverage => {
        claimCoverage.benefits.forEach(benefit => {
          let adjudication = new AdjudicationDO()
          adjudication.levelCd = parseInt(claimDO.adjudicationLevel)
          adjudication.adjDecisionCd = benefitListMap[claimCoverage.productCd][benefit.benefitCd].decisionCd
          adjudication.approvedClaimAmt = benefitListMap[claimCoverage.productCd][benefit.benefitCd].benefitAmt
          adjudication.remarks = benefitListMap[claimCoverage.productCd][benefit.benefitCd].note

          let adjIndex = benefit.adjudications.findIndex(adj => parseInt(adj.levelCd) == parseInt(claimDO.adjudicationLevel))
          if (adjIndex != -1) {
            benefit.adjudications.splice(adjIndex, 1, adjudication)
          }
          else {
            benefit.adjudications.push(adjudication)
          }
        });
      });
    }

    return claimDO['claimCoverages']
  }

  private convertUIBenefitListToMap(benefitList: benefitDO[]) {
    let benefitListMap = {};
    if (benefitList && Array.isArray(benefitList)) {
      benefitList.forEach(benefit => {
        if (benefitListMap[benefit.productCd])
          benefitListMap[benefit.productCd][benefit.benefitCd] = benefit;
        else {
          benefitListMap[benefit.productCd] = {}
          benefitListMap[benefit.productCd][benefit.benefitCd] = benefit;
        }
      });
    }
    return benefitListMap;
  }

  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    }
    else {
      dateString = '-'
    }
    return dateString
  }



}


